import { useState } from 'react';
import api, { ApiError } from '../api/client.js';

export default function Login({ onSignedIn, appTitle, orgName }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitting) return;

    setError('');
    setSubmitting(true);
    try {
      const result = await api.login(username, password);
      onSignedIn(result.user);
    } catch (caught) {
      setError(
        caught instanceof ApiError ? caught.message : 'تعذّر تسجيل الدخول'
      );
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="header-seal" aria-hidden="true">
            ✦
          </div>
          <h1>{appTitle}</h1>
          <p>{orgName}</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {error && (
            <div className="form-error" role="alert">
              {error}
            </div>
          )}

          <div className="field">
            <label htmlFor="login-username">اسم المستخدم</label>
            <input
              id="login-username"
              name="username"
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck="false"
              dir="ltr"
              required
              autoFocus
            />
          </div>

          <div className="field">
            <label htmlFor="login-password">كلمة المرور</label>
            <input
              id="login-password"
              name="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              dir="ltr"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: '11px' }}
            disabled={submitting}
          >
            {submitting ? '...جاري الدخول' : 'تسجيل الدخول'}
          </button>
        </form>
      </div>
    </div>
  );
}
